import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20room%20with%20glowing%20red%20curtains%20and%20spotlight%20on%20center%20stage%2C%20dramatic%20lighting%2C%20luxurious%20atmosphere%2C%20golden%20accents%2C%20elegant%20movie%20theater%20interior%2C%20professional%20photography&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
        alt="大师兄影视"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50" />

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6 w-full">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
          <span className="text-xs font-medium text-primary-300 whitespace-nowrap">每日更新 · 新片速递</span>
        </div>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-4 leading-tight max-w-3xl">
          最新上映热播推荐
          <span className="block text-primary-400 mt-1">更新快抢先看</span>
        </h1>

        <p className="text-sm md:text-base text-foreground-300/80 max-w-xl mb-8 leading-relaxed">
          高清免费在线观看不卡顿，全集播放电影大全一网打尽。<br className="hidden md:block" />
          第一时间更新最新上映电影、热播电视剧、综艺节目。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer no-underline whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-play-circle-line text-lg"></i>
            立即探索
          </Link>
          <Link
            to="/category?type=movie"
            className="px-8 py-3 rounded-full bg-white/10 backdrop-blur-sm text-white font-medium text-sm hover:bg-white/20 transition-all duration-300 cursor-pointer no-underline whitespace-nowrap border border-white/20 flex items-center gap-2"
          >
            <i className="ri-film-line"></i>
            最新电影
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10">
          {[
            { icon: "ri-fire-line", label: "每日更新", value: "50+" },
            { icon: "ri-movie-2-line", label: "影片总量", value: "10万+" },
            { icon: "ri-user-heart-line", label: "在线用户", value: "100万+" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <span className="block text-lg md:text-xl font-bold text-white">{stat.value}</span>
              <span className="text-xs text-foreground-300/70">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}